<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    agentOrganizationList: Array,
    sourceData: Object,
    needRefresh: Boolean
  },
  data() {
    const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      pageCount,
      activePage: this.sourceData.number + 1
    };
  },
  methods: {
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "agentOrganization", params);
    },
    onClick(row) {
      this.$router.push({
        path: `/index/medicalEstablishment/organizationDetail/${row.id}`
      });
    }
  }
};
</script>

<template>
  <div class="AgentOrganizationsIndex">
    <el-table
      @row-click="onClick"
      :data="agentOrganizationList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <!-- <el-table-column prop="stationId" align="left" label="机构ID" width="100"></el-table-column> -->
      <el-table-column prop="name" align="left" label="机构名称" width="150"></el-table-column>
      <el-table-column prop="district" align="left" label="所属城市" min-width="60"></el-table-column>
      <el-table-column prop="lastMonth" align="left" label="上月销量(疗程)" min-width="90"></el-table-column>
      <el-table-column prop="month" align="left" label="本月销量(疗程)" min-width="90"></el-table-column>
      <el-table-column prop="sweekSalesales" align="left" label="最近一周销量" min-width="90">
        <template slot-scope="scope">
          <span class="weeklySale">
            <span
              v-for="(item, index) in scope.row.sweekSalesales"
              :key="index+scope.row.id"
            >{{item}}</span>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="month" align="left" label="趋势图">
        <template slot-scope="scope">
          <el-checkboxå
            v-for="item in scope.row.auths"
            :key="scope.row.id + item"
            v-model="checkBoxSelect"
            class="checkBoxLabel"
            disabled
          >{{item}}</el-checkbox>
        </template>
      </el-table-column>-->
    </el-table>
    <PagenationContainer>
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentOrganizationsIndex {
  .AgencyAccountTable {
    margin: 20px auto;
    border: 1px;
    width: 97%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    .weeklySale {
      display: flex;
      justify-content: space-around;
    }
    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Agent/AgentOrganization.vue